// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundHint, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const avatarSize = "32px";
const shadowColor = "rgba(50, 50, 50, 0.16)";
const titleSize = "14px";
const messageSize = "13px";
const rootPadding = "10px";
const rightPadding = "24px";
const rootWidth = "294px";
const rootHeight = "76px";

export const NotificationCardStyles = (config: DesignSystem) => ({
    notificationCardContainer: {
        position: "relative",
        padding: rootPadding,
        [applyLocalizedProperty("padding-right", "padding-left", config.direction)]: rightPadding,
        width: rootWidth,
        height: rootHeight,
        background: neutralLayerCard,
        "box-shadow": "0px 0px 12px " + shadowColor,
        "border-radius": "6px",
        "box-sizing": "unset !important",

        "& .cwt-close-button": {
            position: "absolute",
            top: "16px",
            [applyLocalizedProperty("right", "left", config.direction)]: "8px",
            background: "none",
            border: "none"
        },

        "& .cwt-notification-header": {
            display: "flex",
            "align-items": "center",

            "& .cwt-image-container": {
                display: "inline-flex",

                "& .cwt-avatar": {
                    height: avatarSize,
                    "min-width": avatarSize,
                    "max-width": avatarSize,
                    display: "block"
                },

                "& .cwt-not-clickable": {
                    cursor: "default"
                },
                "& .cwt-not-round": {
                    "border-radius": "0",
                    "object-fit": "contain"
                }
            },

            "& .cwt-title": {
                margin: "0 10px",
                "font-weight": "600",
                "font-size": titleSize,
                color: neutralForegroundRest,
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis"
            }
        },

        "& .cwt-message": {
            margin: "4px",
            "font-size": messageSize,
            color: neutralForegroundHint,
            display: "flex",
            "align-items": "center",
            height: "42px",
            "& *": {
                display: "inline"
            },
            "& .cwt-name.cwt-link": {
                "font-weight": "600",

                "&::before": {
                    content: "'@'",
                    display: "inline"
                }
            },
            "& > .cwt-clamp": {
                display: "-webkit-box",
                "-webkit-line-clamp": "2",
                "-webkit-box-orient": "vertical",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "line-height": "17px",
                "max-height": "38px"
            }
        }
    }
});